export default class EmailInfo {
  emailAddress: string;
  emailSubject: string;
  emailMessage: string;
  senderName: string;
  jobId: number;

  constructor() {
    this.emailAddress = '';
    this.emailSubject = '';
    this.emailMessage = '';
    this.senderName = '';
    this.jobId = 0;
  }
}
